import axios from "axios";
import Config from "../../../config";

const v2_actionAddScoringDefinition = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/crm/scoring/definitions/criar`,
        data
    });
};

export default v2_actionAddScoringDefinition;
